import { useEffect, useState } from 'react'

import classes from './TransitionContainer.module.css'

const TransitionContainer = ({children}) => {
    const [inView, setInView] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setInView(true)
        }, 100);
    }, [])
    return <div className={`${classes.container} ${inView ? classes.in_view : ''}`}>{children}</div>
}

export default TransitionContainer